module.exports = __webpack_public_path__ + "img/about.42de939c.png";